import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {FETCH_STATUS} from '../../../../react/fetch/fetch-status.model';

@Component({
    selector: 'fetch-article-usage-state-label',
    templateUrl: './fetch-article-usage-state-label.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FetchArticleUsageStateLabelComponent {
  @Input() fetchState: number;
  @Input() articleUsageState: number;
  protected readonly FETCH_STATUS = FETCH_STATUS;
}
